import React from 'react';
import { Badge } from '../ui/badge';

const METHOD_COLORS = {
  GET: 'bg-green-100 text-green-700',
  POST: 'bg-blue-100 text-blue-700',
  PUT: 'bg-yellow-100 text-yellow-700',
  DELETE: 'bg-red-100 text-red-700',
  PATCH: 'bg-purple-100 text-purple-700',
  HEAD: 'bg-gray-100 text-gray-700',
  OPTIONS: 'bg-gray-100 text-gray-700'
};

export const MethodBadge = ({ method }) => {
  return (
    <Badge className={`${METHOD_COLORS[method] || 'bg-gray-100'} font-mono`}>
      {method}
    </Badge>
  );
};

export default MethodBadge;
